// extracted by mini-css-extract-plugin
export default {"container":"_1uk3JpA0rl","checkbox":"_1D4y1AW5Ty","input":"_3dshwZJlIi","label":"_1PldZjJ-pv"};
    if(module.hot) {
      // 1623933148400
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  